import { useSearchParams } from "react-router-dom";
import { simulationPages } from "@app/const/route.const";
import { useAssetClassGenerateLiveChartData } from "@app/pages/assetClassAnalysis/useAssetClassGenerateLiveChartData";
import { PdfDftSingleReport } from "@app/pages/assetClassAnalysis/pdfDistanceFromTrendReport/PdfDftSingleReport";

export const PdfSimulationModelsModelsReport = () => {
  const [searchParams] = useSearchParams();
  const params = simulationPages.getPdfModelsModelsReportParams(searchParams);

  const data = useAssetClassGenerateLiveChartData({
    assetClassLevel4Id: params.assetClassId,
  });

  return (
    <PdfDftSingleReport isLoading={data.isLoading} dftItem={data.dftItem} />
  );
};
